import React from 'react'
import useFetch from "../hooks/useFetch";
import {Container, Row, Col} from "react-bootstrap";
import {BlocksRenderer} from "@strapi/blocks-react-renderer";

export default function Home() {
    const { loading, error, data } = useFetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/articles?sort[0]=Date:desc&populate=*', {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })

    if (loading) return <p>loading...</p>
    if (error) return <p>Error :(</p>


    console.log(data)

    return(
        <div>
            <Container fluid="md">
                {data.data.map(newsitem => (
                    <Row>
                        <Col>
                            <div key={newsitem.documentId} className="news-item">
                                <h2>{newsitem.Title}</h2>
                                {newsitem.Image && <img src={newsitem.Image.url} />}
                                <div><BlocksRenderer content={newsitem.Text}/></div>
                                {newsitem.File && <a href={newsitem.File.url}>{newsitem.File.name}</a>}
                            </div>
                        </Col>
                    </Row>
                ))}
                </Container>
        </div>
    )

}